import React from "react";

import styles from "./styles.scss";

function Version() {
  return <p className={styles.version}>v7.7.1</p>;
}

export { Version };
